import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src686654366/src/EDGAR_MARCANO/msintapujo/node_modules/next/dist/client/app-dir/link.js");
